// import { coreActions } from 'app-components/flux/core-actions';
import { handleActions } from 'redux-actions';

import type { QcsSyncResourceStore, QcsSyncResourceStoreProps } from 'app-components/flux/core/resourceStoreTypes';

import { resourceUndoUpserters, resourceUpserters } from '../core';
import * as actions from './freeToSpendActions';
import { type FreeToSpendPropsImmu, mkFreeToSpend, mkFreeToSpendStore } from './freeToSpendTypes';

const freeToSpendReducer = handleActions<
  QcsSyncResourceStore<FreeToSpendPropsImmu>,
  // | coreActions.SanitizeAction
  | ReturnType<typeof actions.getFreeToSpend>
  | ReturnType<typeof actions.getFreeToSpendSuccess>
  | ReturnType<typeof actions.getFreeToSpendFailure>
  | ReturnType<typeof actions.updateFreeToSpend>
  | ReturnType<typeof actions.updateFreeToSpendSuccess>
  | ReturnType<typeof actions.updateFreeToSpendOptimistic>
  | ReturnType<typeof actions.updateFreeToSpendFailure>
  | ReturnType<typeof actions.updateFreeToSpendsBump>
  // | ReturnType<typeof actions.createPlannedSpending>
  // | ReturnType<typeof actions.deletePlannedSpending>
>(
  {
    [actions.updateFreeToSpend.type]: (state, action) => {
      // An update can be a plain patch, which merges into the stored plan.
      const existing = action.payload.id ? state.resourcesById.get(action.payload.id) : undefined;
      const payload = existing
        ? resourceUpserters.mergeDeepEx<FreeToSpendPropsImmu>(existing, action.payload)
        : mkFreeToSpend(action.payload);
      return resourceUndoUpserters.upsertResourceSetupUndo<
        FreeToSpendPropsImmu,
        QcsSyncResourceStoreProps<FreeToSpendPropsImmu>
      >(state, { ...action, payload }, actions.updateFreeToSpend);
    },

    [actions.updateFreeToSpendOptimistic.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend),

    [actions.updateFreeToSpendSuccess.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResource(state, freeToSpend),

    [actions.updateFreeToSpendsBump.type]: (state, { payload: freeToSpend }) =>
      resourceUpserters.upsertResources(state, freeToSpend),

    [actions.updateFreeToSpendFailure.type]: (state, { payload: error }) =>
      resourceUpserters.resetResources(state, error),

    [actions.getFreeToSpend.type]: (state) => state.merge({ isLoading: true }),
    [actions.getFreeToSpendSuccess.type]: (state, { payload: resources }) => {
      const newState = resourceUpserters.upsertResources(state, resources);
      return newState;
    },
    [actions.getFreeToSpendFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  mkFreeToSpendStore(),
);
export default freeToSpendReducer;
